module.exports = __webpack_public_path__ + "img/activity-banner-2.c4f51fbc.png";